module.exports = __webpack_public_path__ + "images/7a3931f6c72463b01e522f1b6eff9e22-no-icon.png";